import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { TabContainer } from 'smartsuite-ui/lib/containers/TabContainer';
import { Tab } from 'smartsuite-ui/lib/containers/Tab';
import { useLabelContext } from '../shared/hooks/labelContext';
import { editorTabs } from '../shared/constants/constants';

export default function EditorTabs(props) {
    const { activeTab, selectedWidget, setActiveTab } = props;
    const { dashboardLabels } = useLabelContext();

    return (
        <TabContainer>
            <Tab
                isActive={activeTab === editorTabs.widgetLibrary}
                onClick={() => setActiveTab(editorTabs.widgetLibrary)}
            >
                <div className="editor-tabs__tab">
                    {dashboardLabels.widgetLibrary}
                </div>
            </Tab>
            {!isEmpty(selectedWidget) && (
                <Tab
                    isActive={activeTab === editorTabs.editWidget}
                    onClick={() => setActiveTab(editorTabs.editWidget)}
                >
                    <div className="editor-tabs__tab">
                        {dashboardLabels.editWidget}
                    </div>
                </Tab>
            )}
        </TabContainer>
    );
}

EditorTabs.propTypes = {
    activeTab: PropTypes.string.isRequired,
    selectedWidget: PropTypes.instanceOf(Object),
    setActiveTab: PropTypes.func.isRequired,
};
